<template>
  <li>
    <div class="number">
      <div v-if="widgetInfo.value != null && widgetInfo.value >= 0 && !isNaN(widgetInfo.value)">
        <span class="num">{{widgetInfo.value}}</span>
        <span class="unit">{{widgetInfo.rscUnit}}</span>
      </div>
      <div v-else-if="widgetInfo.value != null && widgetInfo.rscId === 'AP_RSSI' && !isNaN(widgetInfo.value)">
        <span class="num">{{widgetInfo.value}}</span>
        <span class="unit">{{widgetInfo.rscUnit}}</span>
      </div>
      <span v-else-if="widgetInfo.value != null && isNaN(widgetInfo.value)">{{ widgetInfo.value }}</span>
      <span class="num" v-else>{{ EMPTY_TEXT }}</span>
    </div>
    <div>
      <span v-if="legendInfo.isLegend === true && legendInfo.index > -1" class="item" :style="{ backgroundColor: chartColorSet[legendInfo.index] }"></span>
      <span>{{widgetInfo.label}}</span>
    </div>
  </li>
</template>

<script>
import { isNil } from 'lodash';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT } from '@/utils/string';
import { chartColorSet } from '@/constants/chart-options';

export default {
  name: 'WPerfFooterVInfo',
  props: {
    widgetInfo: {
      type: Object,
      default: () => ({}),
    },
    legendInfo: {
      type: Object,
      default: () => ({ isLegend: false }), // footer에서 범례표현을 안하는 경우 false
    },
  },
  data() {
    return {
      EMPTY_TEXT,
      chartColorSet,
    };
  },
  watch: {
    widgetInfo: {
      handler(widgetValue) {
        if (isNil(widgetValue.label)) {
          widgetValue.label = widgetValue.rscName;
        }
        if (widgetValue.rscUnit && widgetValue.rscUnit.toUpperCase() === 'COUNT') {
          widgetValue.rscUnit = '';
        } else if (widgetValue.rscUnit && !isNaN(Number(widgetValue.value))) {
          let convertedValue = convertValuByUnit(widgetValue.value, widgetValue.rscUnit, true, true, false);
          if (convertedValue) {
            // convertedValue에서 unit 추출
            const convertedUnit = convertedValue.replace(/^[-]?[0-9]*[.]?[0-9]*[ ]?/g, '');
            convertedValue = convertedValue.split(convertedUnit)[0].replace(/[ ]?/g, '');
            widgetValue.value = convertedValue;
            widgetValue.rscUnit = convertedUnit;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/PerfFooterVInfo.vue